export const analyticsCategory = 'GLOBAL_NAV_MENU'
